import UserFeedback from '../userFeedback';

/**
 * Create the action
 */

const { thunk, request, success, error } = UserFeedback.store((data, fetch) => {
    // Prepare request
    const formData = new FormData();

    Object.keys(data).map(function (key) {
        formData.append(key, data[key]);
    });

    return fetch.post('/feedback', formData);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
